import { styled } from '@mui/system';
import { TableHead } from '@mui/material';

export const StyledTableHead = styled(TableHead)(() => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '.5rem',
  paddingBottom: '0',
  width: '100%',
  gap: '4px',
}));
